<div class="vh-100 d-flex flex-column bg-gray position-fixed top-0 start-0 w-100">
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></Navbar>
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar />
        </div>
      </div>

      <div class="col h-100 overflow-auto">
        <div class="container-fluid p-2">
          <section class="card border shadow-sm rounded overflow-hidden mb-3 bg-light">
            <div class="card-body p-3 p-lg-4">
              <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                <div>
                  <h4 class="fw-bold text-dark mb-1 fs-4">System Promo Codes</h4>
                  <p class="text-muted mb-0 small">
                    Create and manage promo codes that admins can attach across the system.
                  </p>
                </div>

                <button
                  v-if="is_admin"
                  type="button"
                  class="btn btn-primary btn-sm rounded px-3 d-inline-flex align-items-center gap-2 align-self-start align-self-lg-center"
                  @click="open_create_modal">
                  <span>Promo Code</span>
                </button>
              </div>
            </div>
          </section>

          <section v-if="!is_admin" class="card border shadow-sm rounded bg-light">
            <div class="card-body text-center p-5">
              <i class="bi bi-shield-lock text-muted display-6"></i>
              <h6 class="fw-bold text-dark mt-3 mb-1">Admin Access Required</h6>
              <p class="text-muted small mb-0">Only system admins can manage promo codes.</p>
            </div>
          </section>

          <template v-else>
            <section class="row g-3 mb-3">
              <div class="col-12 col-md-4">
                <div class="card border shadow-sm rounded bg-light h-100">
                  <div class="card-body p-3">
                    <p class="text-muted text-uppercase small fw-semibold mb-1">Total Codes</p>
                    <h5 class="fw-bold text-dark mb-0">{{ promo_codes.length }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="card border shadow-sm rounded bg-light h-100">
                  <div class="card-body p-3">
                    <p class="text-muted text-uppercase small fw-semibold mb-1">Active Codes</p>
                    <h5 class="fw-bold text-success mb-0">{{ active_promo_count }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="card border shadow-sm rounded bg-light h-100">
                  <div class="card-body p-3">
                    <p class="text-muted text-uppercase small fw-semibold mb-1">Discount Types</p>
                    <h5 class="fw-bold text-dark mb-0">{{ discount_types.length }}</h5>
                  </div>
                </div>
              </div>
            </section>

            <section class="card border shadow-sm rounded overflow-hidden bg-light">
              <div class="card-body p-3 p-lg-4">
                <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-3">
                  <div>
                    <h6 class="fw-bold text-dark mb-1">Promo Code Library</h6>
                    <p class="text-muted small mb-0">Search, edit, activate, or remove system promo codes.</p>
                  </div>

                  <div class="d-flex flex-column flex-sm-row gap-2">
                    <div class="input-group rounded bg-white border shadow-sm">
                      <span class="input-group-text bg-white border-0">
                        <i class="bi bi-search text-muted"></i>
                      </span>
                      <input
                        v-model="promo_query"
                        type="text"
                        class="form-control border-0 shadow-none bg-white"
                        placeholder="Search promo codes..."
                      />
                    </div>
                    <select v-model="promo_status_filter" class="form-select form-select-sm bg-white border shadow-sm">
                      <option value="all">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div v-if="is_loading" class="text-center p-5">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="text-muted small mt-2 mb-0">Loading promo codes...</p>
                </div>

                <div v-else-if="filtered_promo_codes.length" class="table-responsive">
                  <table class="table align-middle bg-white rounded overflow-hidden mb-0">
                    <thead class="table-light">
                      <tr>
                        <th class="text-muted small text-uppercase">Promo Code</th>
                        <th class="text-muted small text-uppercase">Type</th>
                        <th class="text-muted small text-uppercase">Discount</th>
                        <th class="text-muted small text-uppercase">Min Order</th>
                        <th class="text-muted small text-uppercase">Usage</th>
                        <th class="text-muted small text-uppercase">Start Date</th>
                        <th class="text-muted small text-uppercase">End Date</th>
                        <th class="text-muted small text-uppercase text-center">Status</th>
                        <th class="text-muted small text-uppercase text-end">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="promo in filtered_promo_codes" :key="promo.id">
                        <td>
                          <span class="fw-bold text-xs">{{ get_promo_name(promo) }}</span>
                        </td>
                        <td>
                          <span class=" text-xs text-capitalize">
                            {{ get_promo_type_name(promo) }}
                          </span>
                        </td>
                        <td class="text-xs fw-semibold text-dark">{{ format_discount(promo) }}</td>
                        <td class="text-xs fw-semibold text-dark">R{{ format_amount(get_promo_minimum_order_amount(promo)) }}</td>
                        <td class="text-xs">
                          <span v-if="Number(get_promo_usage_limit(promo) || 0) > 0">
                            {{ get_promo_usage_count(promo) }} / {{ get_promo_usage_limit(promo) }}
                          </span>
                          <span v-else class="badge bg-light text-dark">
                            {{ get_promo_usage_count(promo) }} / <i class="bi bi-infinity fw-500"></i>
                          </span>
                        </td>
                        <td class="text-xs">{{ format_date(get_promo_start_date(promo)) }}</td>
                        <td class="text-xs text-danger">{{ format_date(get_promo_end_date(promo)) }}</td>
                        <td class="text-center">
                          <div class="form-check form-switch d-inline-flex align-items-center justify-content-center">
                            <input
                              class="form-check-input shadow-none"
                              type="checkbox"
                              :checked="is_promo_active(promo)"
                              @change="toggle_promo_status(promo)"
                            />
                          </div>
                        </td>
                        <td class="text-end">
                          <button type="button" class="btn btn-sm text-primary" title="Edit promo code" @click="open_edit_modal(promo)">
                            <i class="bi bi-pencil-square"></i>
                          </button>
                          <button type="button" class="btn btn-sm text-danger" title="Delete promo code" @click="delete_promo_code(promo)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else class="text-center p-5 bg-white rounded border">
                  <i class="bi bi-ticket-perforated text-muted display-6"></i>
                  <h6 class="fw-bold text-dark mt-3 mb-1">No Promo Codes Found</h6>
                  <p class="text-muted small mb-0">Create a promo code to start building the system library.</p>
                </div>
              </div>
            </section>
          </template>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div class="modal fade" id="system_promo_code_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white text-xs fw-bold">
              {{ promo_form.id ? 'Edit Promo Code' : 'Create Promo Code' }}
            </h5>
            <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <form @submit.prevent="submit_promo_code" novalidate>
            <div class="modal-body p-3 p-lg-4">
              <div class="mb-3">
                <label class="form-label text-xxs fw-semibold text-muted">Promo Code</label>
                <input
                  v-model="promo_form.promo_code_name"
                  type="text"
                  class="form-control form-control-sm rounded shadow-none"
                  placeholder="Leave blank to auto-generate"
                />
                <p v-if="promo_errors.promo_code_name" class="text-danger text-xxs mt-1 mb-0">
                  {{ promo_errors.promo_code_name }}
                </p>
              </div>

              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-semibold text-muted">Discount Type <span class="text-danger">*</span></label>
                  <select v-model="promo_form.promo_code_type_id" class="form-select form-select-sm rounded shadow-none">
                    <option value="" disabled>Select type</option>
                    <option v-for="type in discount_types" :key="type.id" :value="type.id">
                      {{ type.label }}
                    </option>
                  </select>
                  <p v-if="promo_errors.promo_code_type_id" class="text-danger text-xxs mt-1 mb-0">
                    {{ promo_errors.promo_code_type_id }}
                  </p>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-semibold text-muted">Discount Value <span class="text-danger">*</span></label>
                  <input
                    v-model="promo_form.discount_amount"
                    type="number"
                    min="0"
                    step="0.01"
                    class="form-control form-control-sm rounded shadow-none"
                  />
                  <p v-if="promo_errors.discount_amount" class="text-danger text-xxs mt-1 mb-0">
                    {{ promo_errors.discount_amount }}
                  </p>
                </div>
              </div>

              <div class="row g-3 mt-0">
                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-semibold text-muted">Valid Start Date</label>
                  <input
                    v-model="promo_form.valid_start_date"
                    type="datetime-local"
                    class="form-control form-control-sm rounded shadow-none"
                  />
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-semibold text-muted">Valid End Date</label>
                  <input
                    v-model="promo_form.valid_end_date"
                    type="datetime-local"
                    class="form-control form-control-sm rounded shadow-none"
                    :min="promo_form.valid_start_date || null"
                  />
                  <p v-if="promo_errors.valid_end_date" class="text-danger text-xxs mt-1 mb-0">
                    {{ promo_errors.valid_end_date }}
                  </p>
                </div>
              </div>

              <div class="row g-3 mt-0 align-items-end">
                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-semibold text-muted">Usage Limit</label>
                  <input
                    v-model.number="promo_form.usage_limit"
                    type="number"
                    min="0"
                    class="form-control form-control-sm rounded shadow-none"
                    placeholder="e.g. 100"
                  />
                  <p v-if="promo_errors.usage_limit" class="text-danger text-xxs mt-1 mb-0">
                    {{ promo_errors.usage_limit }}
                  </p>
                </div>

                <div class="col-12 col-md-6">
                  <label class="form-label text-xxs fw-semibold text-muted">Minimum Order Amount</label>
                  <input
                    v-model.number="promo_form.minimum_order_amount"
                    type="number"
                    min="0"
                    step="0.01"
                    class="form-control form-control-sm rounded shadow-none"
                    placeholder="e.g. 500"
                  />
                  <p v-if="promo_errors.minimum_order_amount" class="text-danger text-xxs mt-1 mb-0">
                    {{ promo_errors.minimum_order_amount }}
                  </p>
                </div>
              </div>

              <div class="row g-3 mt-0">
                <div class="col-12 col-md-6">
                  <div class="form-check form-switch mt-2">
                    <input
                      v-model="promo_form.is_active"
                      type="checkbox"
                      class="form-check-input shadow-none"
                      id="system_promo_is_active"
                    />
                    <label class="form-check-label text-xxs fw-semibold" for="system_promo_is_active">
                      Active
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer border-top bg-light">
              <button type="button" class="btn btn-sm btn-outline-secondary rounded px-3" data-bs-dismiss="modal">
                Cancel
              </button>
              <button type="submit" class="btn btn-sm btn-primary rounded px-3" :disabled="is_saving">
                <span v-if="is_saving" class="spinner-border spinner-border-sm me-2" role="status"></span>
                <span>{{ is_saving ? 'Saving...' : (promo_form.id ? 'Update' : 'Create') }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</div>
